<template>
  <div>
    <!-- Add Accounts -->
    <button @click="showImportModal = true"
      class="absolute left-0 top-0 bg-green-500/30 text-white text-center p-3 rounded cursor-pointer">
      <i class="fa-solid fa-file-import"></i> Import Data
    </button>

    <DetailsModal :open="showImportModal" @close="showImportModal = false" :show-ok-btn="false" w="xl">
      <!-- Header -->
      <div class="border-b border-gray-200 pb-4 mb-6">
        <h2 class="text-2xl font-semibold text-gray-900">Import Data</h2>
        <p class="text-sm text-gray-600 mt-1">Upload an Excel file to import client data</p>
      </div>

      <!-- File Uploader -->
      <FileUploader accept=".xlsx" :custom-url="`clients/import/excel?clientId=${clientId || ''}`"
        @uploaded="(res) => { importResponse = res; $emit('imported') }" class="mb-6">
        <div
          class="h-[240px] flex items-center justify-center bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors duration-200 cursor-pointer">
          <div class="flex flex-col items-center gap-3 text-center px-4">
            <div class="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
              <i class="fa-solid fa-file-excel text-3xl text-blue-600"></i>
            </div>
            <div>
              <h4 class="text-base font-medium text-gray-900">Upload Excel File</h4>
              <p class="text-sm text-gray-500 mt-1">Click to browse and select a excel file to upload client data
                <span v-if="clientId">(for this client)</span>
              </p>
            </div>
            <p class="text-xs text-gray-400">Supported format: .xlsx</p>
          </div>
        </div>
      </FileUploader>

      <!-- Results Section -->
      <div v-if="importResponse" class="space-y-6">
        <!-- Success Section -->
        <div v-if="importResponse?.success?.length > 0" class="bg-green-50 border border-green-200 rounded-lg p-5">
          <div class="flex items-start gap-3">
            <div class="flex-shrink-0">
              <i class="fa-solid fa-circle-check text-green-600 text-xl"></i>
            </div>
            <div class="flex-1">
              <h5 class="text-base font-semibold text-green-900 mb-3">
                Successfully Imported ({{ importResponse.success.length }})
              </h5>
              <div class="flex flex-wrap gap-2">
                <span v-for="(item, index) in importResponse.success" :key="index"
                  class="inline-flex items-center px-3 py-1 bg-white border border-green-300 rounded-md text-sm text-green-800 font-medium">
                  {{ item.tagNo }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Error Section -->
        <div v-if="importResponse?.error?.length > 0" class="bg-red-50 border border-red-200 rounded-lg p-5">
          <div class="flex items-start gap-3">
            <div class="flex-shrink-0">
              <i class="fa-solid fa-circle-exclamation text-red-600 text-xl"></i>
            </div>
            <div class="flex-1">
              <h5 class="text-base font-semibold text-red-900 mb-3">
                Failed to Import ({{ importResponse.error.length }})
              </h5>
              <ul class="space-y-2">
                <li v-for="(item, index) in importResponse.error" :key="index" class="flex items-start gap-2 text-sm">
                  <span class="text-red-600 mt-0.5">•</span>
                  <span class="text-red-800">
                    <span class="font-medium">{{ item.tagNo }}</span>
                    <span class="text-red-600"> - {{ item.error }}</span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Summary -->
        <div class="flex items-center justify-between pt-4 border-t border-gray-200">
          <div class="text-sm text-gray-600">
            <span class="font-medium">Total Processed:</span>
            {{ (importResponse?.success?.length || 0) + (importResponse?.error?.length || 0) }}
          </div>
          <button @click="importResponse = null" class="text-sm text-blue-600 hover:text-blue-800 font-medium">
            Clear Results
          </button>
        </div>
      </div>
    </DetailsModal>
  </div>
</template>

<script>
import DetailsModal from './DetailsModal.vue';
import FileUploader from './FileUploader.vue';


export default {
  name: "ImportData",
  components: { DetailsModal, FileUploader, },
  props: {
    clientId: Number,
  },
  data() {
    return {
      showImportModal: false, // Modal visibility
      importResponse: { success: [], error: [] }
    };
  },
  methods: {
    //
  },
};
</script>
